// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UndoOutlinedSvg from "@ant-design/icons-svg/es/asn/UndoOutlined";
import AntdIcon from '../components/AntdIcon';

var UndoOutlined = function UndoOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UndoOutlinedSvg
  }));
};

UndoOutlined.displayName = 'UndoOutlined';
export default React.forwardRef(UndoOutlined);